var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheakedOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827",
    transform: "translate(-746 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_51_",
    "data-name": "svgexport-6 (51)",
    transform: "translate(835.25 185.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check_Mark",
    d: "M38.979,61.729,67.417,33.292A2.843,2.843,0,0,0,63.4,29.271L36.969,55.7,27.6,46.333a2.843,2.843,0,1,0-4.021,4.021L34.958,61.729a2.842,2.842,0,0,0,4.021,0Z",
    transform: "translate(-89 -2)",
    fill: "#2da381"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_51_2",
    "data-name": "svgexport-6 (51)",
    transform: "translate(746 184)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check_Mark-2",
    "data-name": "Check_Mark",
    d: "M45.5,91A45.5,45.5,0,1,1,91,45.5,45.552,45.552,0,0,1,45.5,91Zm0-85.312A39.813,39.813,0,1,0,85.313,45.5,39.857,39.857,0,0,0,45.5,5.688Z",
    fill: "#2da381"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheakedOutline);
export default __webpack_public_path__ + "static/media/cheaked-outline.43ebd52c5afe183e1e5f9e37b02cddf5.svg";
export { ForwardRef as ReactComponent };